import './Content.scss';

import cn from 'classnames';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Picture from '@/common/components/atoms/Picture/Picture';
import cartPicture from '@/ebat/assets/images/scanbat-cart.png';
import CartItem from '@/ebat/components/blocks/Scanbat/Cart/CartItem/CartItem';

import { ContentDefaultProps, ContentPropTypes } from './Content.proptypes';

const Content = ({
  cart,
  className,
  currentItems,
  disabled,
  isLoading,
  isUpdated,
  onModifyItem,
  onRemoveItem,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn('scanbat-content', className)}>
      {currentItems && currentItems.length > 0 ? (
        <ul className="scanbat-content__list">
          {currentItems.map(
            (item) =>
              !item.is_diff && (
                <li
                  className="scanbat-content__item"
                  key={`scanbat-item-${item.id}`}
                >
                  <CartItem
                    agrementFgaz={item.product?.agrement_fgaz}
                    brand={item.product?.brand}
                    disabled={disabled}
                    discountClass={item.discount_class}
                    discountClasses={cart.discount_classes}
                    discountLabel={item.discount_label}
                    // Conflict with discountPrice in withPriceAndStock
                    discountPriceItem={item.discount_price}
                    discountPriceTTC={item.discount_price_incl_vat}
                    publicPrice={
                      item.product?.price_and_stock?.price?.public_price
                    }
                    flags={item.product?.flags}
                    hasPrice={item.product?.price_and_stock?.has_price}
                    hasStock={item.product?.price_and_stock?.has_stock}
                    id={item.id}
                    image={item.product?.image}
                    invoiceUnit={
                      item.invoice_unit ||
                      item.product?.price_and_stock?.invoice_unit
                    }
                    isLoading={isLoading}
                    isSalable={item.is_salable}
                    isSelected={item.is_selected}
                    isSubstitute={item.is_substitute}
                    lineSubtotal={!isUpdated ? item.line_subtotal : null}
                    mainSku={item.product?.main_sku}
                    manufacturerSku={
                      item.product?.manufacturer_sku || item.supplier_reference
                    }
                    mustSubstitute={item.product?.must_substitute}
                    name={item.product?.name || item.label}
                    onModify={onModifyItem}
                    onRemove={onRemoveItem}
                    path={item.product?.path}
                    price={item.price}
                    publicPriceTTC={item.public_price_incl_vat}
                    publicPriceTTCAmount={
                      !isUpdated ? item.line_subtotal_incl_vat : null
                    }
                    quantity={item.quantity}
                    quoteNumber={item.quote_number}
                    saleUnit={
                      item.sale_unit || item.product?.price_and_stock?.sale_unit
                    }
                    salesPackaging={
                      item.product?.price_and_stock?.sales_packaging
                    }
                    sku={item.product?.sku || item.sku}
                    slug={item.product?.slug}
                    splitPackaging={
                      item.product?.price_and_stock?.split_packaging
                    }
                    substitute={item.substitute}
                    weeeAmount={item.weee_amount}
                    weeeTotalAmount={item.weee_total_amount}
                  />
                </li>
              ),
          )}
        </ul>
      ) : (
        <div className="scanbat-content__empty empty">
          <Picture
            className="empty__picture"
            alt={t('ebat:entities:scanbat.cart.empty.picture')}
            src={cartPicture}
            type="static"
          />
          <p className="empty__title">
            {t('ebat:entities:scanbat.cart.empty.title')}
          </p>
          <p className="empty__subtitle">
            <Trans
              allowHTML
              components={{ span: <span /> }}
              i18nKey="ebat:entities:scanbat.cart.empty.subtitle"
            />
          </p>
        </div>
      )}
    </div>
  );
};

Content.defaultProps = {
  ...ContentDefaultProps,
};

Content.propTypes = {
  ...ContentPropTypes,
};

export default Content;
